import { jsx as _jsx } from "react/jsx-runtime";
import { TypographyText } from '../_core';
import styles from '../typography.module.css';
/**
 * Secondary/muted text. ALWAYS renders `<span>` — never the HTML `<caption>`
 * element.
 *
 * 12px sans 500. Muted color baked in — no color prop. For timestamps,
 * helper text, sublabels.
 *
 * Do not override fontSize, fontFamily, lineHeight, fontWeight, or
 * letterSpacing via style prop.
 */
export function Caption({ children, style, ...rest }) {
    return (_jsx(TypographyText, { as: "span", roleClassName: styles.caption, style: style, ...rest, children: children }));
}
//# sourceMappingURL=Caption.js.map